/** @prettier */

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import {useTranslation} from 'react-i18next';

//type import
import {graphProps} from '../../../Type/TypeDef';

import {iconWhite} from '../../../define';

/**
 * グラフのタイトル部
 * @param props props
 * @returns JSX.Element
 */
const GraphHeader = (props: {
  /** グラフへ渡すデータ */
  setGraphParam: graphProps['setGraphParam'];
  /** タイトル名 */
  graphTitle: string;
}) => {
  const trans = useTranslation().t; //翻訳関数

  /** 閉じるボタンを押下時の処理 */
  const close = () => {
    props.setGraphParam('');
  };

  return (
    <Grid container alignItems="center" spacing={2}>
      {/** 閉じるボタン */}
      <Grid item xs="auto">
        <IconButton aria-label="Graph close" onClick={close}>
          <img
            src={iconWhite.CLOSE.src}
            alt={`${trans(
              `GraphAppBar.image.alternativeText.${iconWhite.CLOSE.alt}`
            )}`}
            title={`${trans(
              `GraphAppBar.image.title.${iconWhite.CLOSE.title}`
            )}`}
            className="graph__card__header__icon"
          />
        </IconButton>
      </Grid>
      {/** タイトル */}
      <Grid item xs>
        {props.graphTitle}
      </Grid>
    </Grid>
  );
};

export default GraphHeader;
